export default __webpack_public_path__ + "static/media/icon-time-black.4ab77fa2.svg";